<div>
    <div class="checkout-payments" *ngIf="payments.length > 0; else noPayments">
        <app-payment-item *ngFor="let payment of payments; let i = index"
                          [inExpressMode]="inExpressMode"
                          [payment]="payment"
                          [checked]="payment === checkedPayment && !otherPaymentSelected"
                          [showDivider]="false"
                          [setDefaultOnTap]="setDefaultOnTap"
                          (selectedPayment)="onSelectedPayment('card', $event)"
                          (requestPaymentDeletion)="onDeletedPayment($event)">
        </app-payment-item>
    </div>
    <ng-template #noPayments>
        <div class="empty-checkout-layout mb-3" role="button"
                 mat-ripple
                 matRippleColor="#CCCCCC25"
                 (click)="onAddNewPayment()">
                <span class="material-symbols-rounded square-icon me-3">add</span>
                <div class="my-auto">
                    <h5 class="medium-text m-0">Agrega una forma de pago</h5>
                </div>
            </div>
    </ng-template>
    <div class="py-2" *ngIf="morePayments">
<!--        <div *ngIf="inExpressMode">-->
<!--            <mat-divider></mat-divider>-->
<!--        </div>-->

        <p class="x-small-text text-uppercase spaced-label my-3">Otras formas de pago</p>
        <div class="checkout-payment-item"
             [class.attenuated-accent-primary-btn]="otherPaymentSelected"
             [class.accent-border-color]="otherPaymentSelected && !inExpressMode"
             mat-ripple
             matRippleColor="#CCCCCC25"
             (click)="onSelectedPayment(
             'terminal',
             { type: 'terminal' },
             true
            )">
            <div class="checkout-payment-item-lateral">
                <span class="material-symbols-rounded square-icon">point_of_sale</span>
                <div class="payment-item-text-container">
                    <p class="medium-text">
                        Pago en terminal
                    </p>
                    <p class="small-label">
                        Solicita el procesamiento del pago en el area de CaliScan.
                    </p>
                </div>
<!--                <span class="material-symbols-rounded primary-icon me-3">-->
<!--                        {{-->
<!--                    paymentIdentifier === 'terminal'-->
<!--                    && otherPaymentSelected-->
<!--                        ? 'radio_button_checked'-->
<!--                        : 'radio_button_unchecked'-->
<!--                    }}-->
<!--                </span>-->
            </div>
        </div>
    </div>
</div>


